<template>
  <div class="flex flex-col items-center">
    <div class="mb-4 bg-white p-8 shadow-md rounded-full">
      <vs-icon :icon="icon" :icon-pack="iconPack" size="4rem"/>
    </div>
    <h5 class="py-2 px-4 bg-white shadow-md rounded-full">
      <slot></slot>
    </h5>
  </div>
</template>

<script>
    export default {
        name: 'VxEmpty',
        props: {
            icon: String,
            iconPack: {
                type: String,
                default: 'material-icons'
            },
        },
    }
</script>
